<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-manager-edit-user">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 col-sm-12 p-4">
            <form v-on:submit.prevent="userManagerEditUser">
              <h4>User Manager</h4>
              <hr />
              <h6>Edit User</h6>
              <br />
              <p>*These fields are required</p>
              <div class="row my-3">
                <div class="col-sm-12 col-lg-8 col-md-8">
                  <div class="row my-2">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Username*</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="UserName"></b-form-input>
                      <small>no spaces, must be unique for each user</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Password *</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input
                        v-model="Password"
                        type="password"
                        disabled
                        style="cursor: not-allowed"
                      ></b-form-input>
                      <br />
                      <!-- <router-link
                        :to="{
                          name: 'AdminUserManager',
                        }"
                        class="btn btn-primary btn-lg btn-sm-block mr-2"
                        type="button"
                        >Email Password</router-link
                      > -->
                      <button
                        type="button"
                        @click="sendPassword"
                        class="btn btn-primary d-block"
                      >
                        Email Password
                      </button>
                      <small>(Sends password mail to user)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-lg-4 col-md-4">
                      <p>Points</p>
                    </div>
                    <div class="col-lg-8 col-md-8">
                      <label>{{
                        StartingPoints
                          ? parseInt(StartingPoints)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                          : "0.00"
                      }}</label>
                      <router-link
                        :to="{
                          name: 'AdminUserManagerPoints',
                          params: { userId: UserId },
                        }"
                        class="btn btn-primary btn-lg btn-sm-block m-1"
                      >
                        Points
                      </router-link>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Single Item Only</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-radio-group
                        v-model="SingleItem"
                        :options="SingleItemOptions"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                      <small
                        >(Yes = starting points become max point value for this
                        item)</small
                      >
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Code</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Code2</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Code2"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Client</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-select
                        v-model="SelectClient"
                        :options="SelectClientOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>First Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="FirstName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Middle Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="MiddleName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Last Name</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="LastName"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Address ATTN</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="AddressAtn"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Address</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="Address"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>City</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="City"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>State</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="State"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Zip Code</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="ZipCode"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Day Phone</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="DayPhone"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Evening Phone</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="EveningPhone"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Email</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input type="text" v-model="Email"></b-form-input>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Social Security No.</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="SocialSecurityNo"></b-form-input>
                      <small>(Optional, no dashes. Ex: 123456789)</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Joining Date</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="JoiningDate"></b-form-input>
                      <small>(Month/Day/Year) eg: 12/12/2022</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Birthday</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthDay"></b-form-input>
                      <small>(Month/Day) eg: 12/12</small>
                    </div>
                  </div>
                  <div class="row my-3">
                    <div class="col-sm-12 col-lg-4 col-md-4">
                      <p>Birthyear</p>
                    </div>
                    <div class="col-sm-12 col-lg-8 col-md-8">
                      <b-form-input v-model="BirthYear"></b-form-input>
                      <small>(Year) eg: 2022</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <input
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  type="submit"
                  name="update"
                  value="Update"
                />
                <router-link
                  :to="{
                    name: 'AdminUserManager',
                  }"
                  @click.native="scrollToTop"
                  class="btn btn-primary btn-lg btn-sm-block mr-2"
                  type="button"
                  >Cancel</router-link
                >
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { mapState } from "vuex";
import {
  getCustomizedTimestamp,
  convertToMonthDayYear,
  validateMonthDateYearFormat,
  validateMonthDay,
  validateYear,
} from "@/utilities/date.js";

export default {
  name: "AdminUserManagerEditUser",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  props: {
    userId: Number,
  },

  data() {
    return {
      UserId: this.$route.params.userId,
      Email: "",
      UserName: "",
      Password: "*****",
      StartingPoints: 0,
      SingleItem: false,
      SingleItemOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      Code: "",
      Code2: "",
      SelectClient: null,
      SelectClientOptions: [],
      FirstName: "",
      MiddleName: "",
      LastName: "",
      AddressAtn: "",
      Address: "",
      City: "",
      State: "",
      ZipCode: "",
      DayPhone: "",
      EveningPhone: "",
      SocialSecurityNo: "",
      JoiningDate: "",
      BirthDay: "",
      BirthYear: "",
      Admin: null,
    };
  },

  computed: {
    getUserDetail() {
      return this.$store.getters["userManager/getUserDetail"];
    },
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
  },

  watch: {
    getUserDetail(getUserDetail) {
      this.UserName = getUserDetail.username;
      this.FirstName = getUserDetail.firstName;
      this.LastName = getUserDetail.lastName;
      this.Email = getUserDetail.email;
      this.AddressAtn = getUserDetail.address1;
      this.Address = getUserDetail.address2;
      this.City = getUserDetail.city;
      this.State = getUserDetail.state;
      this.ZipCode = getUserDetail.zip;
      this.SelectClient = Number(getUserDetail.client);
      this.DayPhone = getUserDetail.dayPhone;
      this.EveningPhone = getUserDetail.eveningPhone;
      this.StartingPoints = getUserDetail.pointsAvailable;
      this.SocialSecurityNo = getUserDetail.ssn;
      this.MiddleName = getUserDetail.middleInitial;
      if (getUserDetail.joiningDate) {
        if (getUserDetail.joiningDate === "1900-01-01T00:00:00Z") {
          console.log("01/01/1900")
          this.JoiningDate = "01/01/1900";
        } else {
          console.log("converted", convertToMonthDayYear(getUserDetail.joiningDate))
          this.JoiningDate = convertToMonthDayYear(getUserDetail.joiningDate);
        }
      }else{
        this.JoiningDate = "";
      }

      this.BirthDay = getUserDetail.birthday;
      this.BirthYear = getUserDetail.birthyear;
      this.Code = getUserDetail.code;
      this.Code2 = getUserDetail.code2;
      this.Admin = getUserDetail.admin;
      this.SingleItem = getUserDetail.singleItem;
    },
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function(data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      // this.SelectClient = datas.length > 0 ? datas[0].value : null;
      this.SelectClientOptions = datas;
    },
  },

  created() {
    this.scrollToTop();
    this.$store.dispatch("userManager/fetchUserDetailsById", {
      userId: this.UserId,
    });
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
  },

  destroyed() {
    if (this.$route.name === "AdminUserManager") {
    } else {
      this.$store.commit("userManager/SET_FILTER_DATA_FOR_USER_MANAGER", {
        companyId: 0,
        userType: 0,
        status: 2,
        recordsPerScreen: 5,
        search: "",
      });
    }
  },

  methods: {
    userManagerEditUser: function() {
      if (!this.UserName.trim()) {
        alert("Username is required .");
      }

      this.JoiningDate =
        this.JoiningDate && validateMonthDateYearFormat(this.JoiningDate)
          ? this.JoiningDate
          : "";
      this.BirthDay =
        this.BirthDay && validateMonthDay(this.BirthDay) ? this.BirthDay : "";
      this.BirthYear =
        this.BirthYear && validateYear(this.BirthYear) ? this.BirthYear : "";

      if (this.UserName) {
        const params = {
          user_id: +this.UserId,
          username: this.UserName.trim(),
          code: this.Code,
          code2: this.Code2,
          company: "",
          points: +this.StartingPoints,
          admin: +this.Admin,
          singleitem: this.SingleItem,
          firstname: this.FirstName,
          middleinitial: this.MiddleName,
          lastname: this.LastName,
          address1: this.AddressAtn,
          address2: this.Address,
          city: this.City,
          state: this.State,
          zip: this.ZipCode,
          dayphone: this.DayPhone,
          eveningphone: this.EveningPhone,
          email: this.Email,
          ssn: this.SocialSecurityNo,
          joiningdate: this.JoiningDate,
          birthday: this.BirthDay,
          birthyear: this.BirthYear,
          client_Id: +this.SelectClient,
        };

        this.$store
          .dispatch("userManager/editUserManager", params)
          .then((userId) => {
            console.log("succesfully updated the user", userId);
            this.$router.push({
              name: "AdminUserManagerMessage",
              params: { userId: userId, action: "updated" },
            });
          })
          .catch(() => {
            console.log("error occured ..");
          });
      }
    },
    sendPassword() {
      this.$store
        .dispatch("userManager/emailPassword", {
          userId: this.$route.params.userId,
        })
        .then((data) => {
          alert(data);
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-user-manager-edit-user {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.datetime-style {
  background-color: blue;
}
</style>
